import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
} from "../../../../../Components/Panel/Panel";
import { InputGroup, Input, InputGroupAddon, Button, Alert } from "reactstrap";
import Pagination from "../../../../../Components/Pagination/QSP";
import { commonStatusName } from "../../../../../Components/User/UserNames";
import NumberFormat from "react-number-format";
import { graphqlUri } from "../../../../../Config/Env";

const Presenter = ({
  history,
  match,
  location,
  keyword,
  page,
  take,
  loading,
  data,
  baseUrl,
}) => {
  const { control, handleSubmit, errors } = useForm({
    defaultValues: {
      keyword,
    },
  });

  const onSubmit = async (data) => {
    const baseUrl = "?" + (data.keyword ? "keyword=" + data.keyword + "&" : "");
    history.push(`${baseUrl}page=1`);
  };

  const defaultUrl = baseUrl + "?" + (keyword ? `keyword=${keyword}&` : ``);

  return (
    <div>
      <Helmet>
        <title>묶음 | 한밭페이</title>
      </Helmet>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <Link to="/dashboard">Home</Link>
        </li>
        <li className="breadcrumb-item active">
          <Link to="/delivery/deliveryStores">로컬푸드 구독</Link>
        </li>
        <li className="breadcrumb-item">
          <Link to="/delivery/deliveryProducts">상품</Link>
        </li>
        <li className="breadcrumb-item active">묶음</li>
      </ol>
      <h1 className="page-header">묶음</h1>

      <div className="row">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader noButton={true}>
              목록 ({!loading && data.StoreDeliverySetList.count}건)
            </PanelHeader>
            <Alert className="bg-gray-transparent-1">
              <div className="row">
                <div className="col-xs-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <InputGroup>
                      <Controller
                        control={control}
                        name="keyword"
                        rules={{ required: "검색어(묶음명)를 입력해주세요." }}
                        render={({ onChange, onBlur, value }) => (
                          <input
                            type="text"
                            className="form-control"
                            placeholder="검색어(묶음명)를 입력해주세요."
                            onChange={onChange}
                            onBlur={onBlur}
                            value={value}
                          />
                        )}
                      />
                      <InputGroupAddon addonType="append">
                        <Button type="submit" size="sm" color="white">
                          <i className="fa fa-search fa-fw"></i>
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                    {errors.keyword && (
                      <span className="text-red errorText">
                        {errors.keyword.message}
                      </span>
                    )}
                  </form>
                </div>
              </div>
            </Alert>

            {!loading ? (
              <Fragment>
                {data.StoreDeliverySetList.count > 0 ? (
                  <>
                    <PanelBody>
                      <div className="product-list-wrap">
                        <ul>
                          {data.StoreDeliverySetList.deliverySets.map(
                            (item, index) => {
                              const Cover =
                                item.coverImage === "" ||
                                item.coverImage === null
                                  ? "/assets/img/product/product-default.jpg"
                                  : `${graphqlUri}${item.coverImage}`;
                              return (
                                <li key={index} className="product-list">
                                  <Link
                                    to={`/delivery/deliverySets/${item.id}/edit${location.search}`}
                                  >
                                    <div className="ticket">
                                      <img src={Cover} alt={item.name} />
                                      <div className="category">
                                        <span className="label label-yellow">
                                          {commonStatusName(item.commonStatus)}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="product-list-cont">
                                      <h4 className="tit">{item.name}</h4>
                                      <div className="price-info">
                                        <span className="price">
                                          <NumberFormat
                                            value={item.totalPrice}
                                            prefix={""}
                                            suffix={"드림"}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  </Link>
                                </li>
                              );
                            }
                          )}
                        </ul>
                      </div>
                    </PanelBody>
                    <PanelFooter>
                      <div className="row">
                        <div className="col-md-6">
                          <Pagination
                            totalRecord={data.StoreDeliverySetList.count}
                            blockSize={5}
                            pageSize={take}
                            currentPage={page}
                            baseUrl={defaultUrl}
                          />
                        </div>
                        <div className="col-md-6"></div>
                      </div>
                    </PanelFooter>
                  </>
                ) : (
                  <PanelBody>
                    <p className="text-center">등록된 데이터가 없습니다.</p>
                  </PanelBody>
                )}
              </Fragment>
            ) : (
              <Fragment></Fragment>
            )}
          </Panel>
        </div>
      </div>
      <Link
        to={`${baseUrl}/write${location.search}`}
        className="btn btn-icon btn-circle btn-lg btn-primary btn-scroll-to-top"
      >
        <i className="fas fa-pencil-alt"></i>
      </Link>
    </div>
  );
};

export default Presenter;
